import api from '@/assets/plugins/axios'
import {backendUrl} from '@/assets/js/config'
// let headers = {'Content-type': 'application/x-www-form-urlencoded'};
class UploadHistoryService {
  queryUploadList (params){
    return api.post(`${backendUrl}/upload_history/upload_infos`, params).then(ret => {
      console.log(ret)
      return ret
    })
  }
  queryUploadListBigData (params){
    return api.post(`${backendUrl}/data_manage/upload_infos`, params).then(ret => {
      console.log(ret)
      return ret
    })
  }
  queryUploadResult (params){
    return api.postArr(`${backendUrl}/data_manage/upload_detail?uuid=${params}`, {}).then(ret => {
      console.log(ret)
      return ret
    })
  }
  // ɾ�� ���µ� �����ļ� �ϴ���¼
  deleteUploadPoint (params){
    return api.delete(`${backendUrl}/upload_history/upload_hint?type=${params}`).then(ret => {
      console.log(ret)
      return ret
    })
  }
  // ɾ�� ���µ� �����ļ� �ϴ���¼
  deleteUploadPointBigData (params){
    return api.delete(`${backendUrl}/data_manage/upload_hint?type=${params}`).then(ret => {
      console.log(ret)
      return ret
    })
  }
}
export default new UploadHistoryService()
